<template>
  <div id="products-list">
    <div id="overlay" v-if="searching"></div>
    <div id="searching" v-if="searching" role="alert"><span class="fas fa-spinner fa-spin fa-5x" /></div>
    <div class="row row-eq-height equal">
        <div v-if="products.length === 0" id="no-products" class="col-sm-12">
            {{translations.noproducts}}
        </div>
      <div v-for="(product, index) in products" :key="product.ID" :class="[{'first-product': index === 0}, 'col-xs-12 col-sm-6 col-md-4 col-lg-3']">
        <product 
          :image-alt="product.ImageAlt" 
          :image-url="product.ImageUrl" 
          :id="product.ID" 
          :name="product.Name" 
          :url="product.Url" 
          :campaigns="campaigns" 
          :ih="product.IsIH" 
          :isMedical="product.IsMedicalInstrument" 
          :isSupplement="product.IsSupplement" 
          :new-product="product.IsNewProduct"
          :translations="translations"/>
      </div>
    </div>
  </div>
</template>
<script>
import Product from './Product.vue';

export default {
  props: {
    products: Array,
    campaigns: Array,
    translations: Object,
    searching: false
  },
  components: {Product},

}
</script>
